import browserStorage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import environment, { electronOnly } from "src/utils/environment";
import activityLog from "src/modules/activity-log/duck/reducer";
import app from "src/duck/reducer";
import auth from "src/modules/auth/duck/reducer";
import avatar from "src/modules/avatar/duck/reducer";
import babyStation from "src/modules/baby-station/duck/reducer";
import command from "src/modules/command/duck/reducer";
import device from "src/modules/device/duck/reducer";
import deviceDiscovery from "src/modules/device-discovery/duck/reducer";
import lullaby from "src/modules/lullaby/duck/reducer";
import pairingManually from "src/modules/pairing-manually/duck/reducer";
import pairingRequester from "src/modules/pairing-requester/duck/reducer";
import pairingResponder from "src/modules/pairing-responder/duck/reducer";
import pairing from "src/modules/pairing/duck/reducer";
import scheduler from "src/modules/scheduler/duck/reducer";
import firebase from "src/modules/firebase/duck/reducer";
import soundAlerts from "src/modules/sound-alerts/duck/reducer";

const ElectronStore = window.require("electron-store");
const createElectronStorage = window.require("redux-persist-electron-storage");

let storage = environment.isBrowser ? browserStorage : undefined;
electronOnly(() => {
  const electronStore = new ElectronStore({
    name: "store"
  });
  storage = createElectronStorage({
    electronStore
  });
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "activityLog",
    "avatar",
    "babyStation",
    "command",
    "lullaby",
    "scheduler",
    "soundAlerts"
  ],
  stateReconciler: autoMergeLevel2
};

const rootReducer = combineReducers({
  activityLog,
  app: app.createReducer(storage),
  auth: auth.createReducer(storage),
  avatar,
  babyStation,
  command,
  device,
  deviceDiscovery,
  lullaby,
  pairing,
  pairingManually,
  pairingRequester,
  pairingResponder,
  scheduler,
  soundAlerts,
  firebase: firebase.createReducer(storage)
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
});

const persistor = persistStore(store);

export { store, persistor };
